import axios from "axios";
import { getAuthHeader } from "./auth";

/* organizer */

export const GetOrganizerUser = async (baseUrl, tokenType, token, userName = "") => {
    try {
        const res = await axios.get(
            `${baseUrl}/LoginUser/Organizers?filter=${userName}`,
            {
                headers: {
                    ...getAuthHeader(tokenType),
                    Authorization: `Bearer ${token}`
                }
            }
        );
        return res.data;
    } catch (error) {
        console.error("Error fetching organizer user:", error);
        throw error;
    }
};

export const GetOrganizerProfile = async (baseUrl, tokenType, token, organizerId) => {
    try {
        const res = await axios.get(
            `${baseUrl}/Organizer/${organizerId}`,
            {
                headers: {
                    ...getAuthHeader(tokenType),
                    Authorization: `Bearer ${token}`
                }
            }
        );
        return res.data;
    } catch (error) {
        console.error("Error fetching organizer user:", error);
        throw error;
    }
};

export const UpdateOrganizerProfile = async (baseUrl, tokenType, token, organizerProfileApiModel) => {
    try {
        const res = await axios.put(
            `${baseUrl}/Organizer`,
            organizerProfileApiModel,
            {
                headers: {
                    ...getAuthHeader(tokenType),
                    Authorization: `Bearer ${token}`
                }
            }
        );
        return res.data;
    } catch (error) {
        console.error("Error updating organizer profile:", error);
        throw error;
    }
};

export const OrganizerWithUsernameAlreadyExists = async (baseUrl, tokenType, token, username) => {
    try {
        const res = await axios.get(
            `${baseUrl}/Organizer/${username}/Username?tenant=1`,
            {
                headers: {
                    ...getAuthHeader(tokenType),
                    Authorization: `Bearer ${token}`
                }
            }
        );
        return res.data;
    } catch (error) {
        console.error("Error fetching organizer with username already exists:", error);
        throw error;
    }
};

/* address */

export const UpdateBuyerAddress = async (baseUrl, tokenType, token, orderId, addressApiModel) => {
    try {
        const res = await axios.put(
            `${baseUrl}/Order/${orderId}/Address?updateBuyer=true`,
            addressApiModel,
            {
                headers: {
                    ...getAuthHeader(tokenType),
                    Authorization: `Bearer ${token}`
                }
            }
        );
        return res.data;
    } catch (error) {
        console.error("Error updating buyer address:", error);
        throw error;
    }
};

export const GetAddressOfOrganizer = async (baseUrl, tokenType, token, organizerId) => {
    try {
        const res = await axios.get(
            `${baseUrl}/Organizer/${organizerId}/Address`,
            {
                headers: {
                    ...getAuthHeader(tokenType),
                    Authorization: `Bearer ${token}`
                }
            }
        );
        return res.data;
    } catch (error) {
        console.error("Error fetching address of organizer:", error);
        throw error;
    }
};

export const GetAddressOfOrder = async (baseUrl, tokenType, token, orderId) => {
    try {
        const res = await axios.get(
            `${baseUrl}/Order/${orderId}/Address`,
            {
                headers: {
                    ...getAuthHeader(tokenType),
                    Authorization: `Bearer ${token}`
                }
            }
        );
        return res.data;
    } catch (error) {
        console.error("Error fetching address of order:", error);
        throw error;
    }
};

/* order */

export const CreateShopBasketOrder = async (baseUrl, tokenType, token, orderApiModel) => {
    try {
        const res = await axios.post(
            `${baseUrl}/ShopBasket/Order`,
            orderApiModel,
            {
                headers: {
                    ...getAuthHeader(tokenType),
                    Authorization: `Bearer ${token}`
                }
            }
        );
        return res.data;
    } catch (error) {
        console.error("Error creating order:", error);
        throw error;
    }
};

export const GetShopBasketOrder = async (baseUrl, tokenType, token, orderId) => {
    try {
        const res = await axios.get(
            `${baseUrl}/ShopBasket/Order/${orderId}`,
            {
                headers: {
                    ...getAuthHeader(tokenType),
                    Authorization: `Bearer ${token}`
                }
            }
        );
        return res.data;
    } catch (error) {
        console.error("Error fetching the shopbasket order:", error);
        throw error;
    }
};

export const GetOrders = async (baseUrl, tokenType, token, organizerId = null, includeCancelledOrders = false, filterText = "", numberToSkip = 0, eventId = null) => {
    try {
        // Build URL - if eventId is provided, use eventId filter; otherwise use organizerId filter
        let url = `${baseUrl}/Orders?`;
        
        if (eventId !== null && eventId !== undefined && eventId > 0) {
            // Filter by eventId only
            url += `eventId=${eventId}`;
        } else if (organizerId !== null && organizerId !== undefined) {
            // Filter by organizerId only
            url += `organizerId=${organizerId}`;
        } else {
            throw new Error("Either organizerId or eventId must be provided");
        }
        
        // Add other parameters
        url += `&includeCancelledOrders=${includeCancelledOrders}&filterText=${filterText}&numberToSkip=${numberToSkip}`;
        
        const res = await axios.get(
            url,
            {
                headers: {
                    ...getAuthHeader(tokenType),
                    Authorization: `Bearer ${token}`
                }
            }
        );
        return res.data;
    } catch (error) {
        console.error("Error fetching orders:", error);
        throw error;
    }
};

export const GetCountOrders = async (baseUrl, tokenType, token, organizerId, includeCancelledOrders = false, filterText = "") => {
    try {
        const res = await axios.get(
            `${baseUrl}/Orders/Count?organizerId=${organizerId}&includeCancelledOrders=${includeCancelledOrders}&filterText=${filterText}`,
            {
                headers: {
                    ...getAuthHeader(tokenType),
                    Authorization: `Bearer ${token}`
                }
            }
        );
        return res.data;
    } catch (error) {
        console.error("Error fetching count orders:", error);
        throw error;
    }
};

export const GetOrdersOfBuyer = async (baseUrl, tokenType, token, buyerId, includeCancelledOrders = false, filterText = "", numberToSkip = 0) => {
    try {
        const res = await axios.get(
            `${baseUrl}/Buyer/${buyerId}/Orders?includeCancelledOrders=${includeCancelledOrders}&filterText=${filterText}&numberToSkip=${numberToSkip}`,
            {
                headers: {
                    ...getAuthHeader(tokenType),
                    Authorization: `Bearer ${token}`
                }
            }
        );
        return res.data;
    } catch (error) {
        console.error("Error fetching buyer orders:", error);
        throw error;
    }
};

export const CountBuyerOrders = async (baseUrl, tokenType, token, buyerId, includeCancelledOrders = false, filterText = "") => {
    try {
        const res = await axios.get(
            `${baseUrl}/Buyer/${buyerId}/Orders/Count?includeCancelledOrders=${includeCancelledOrders}&filterText=${filterText}`,
            {
                headers: {
                    ...getAuthHeader(tokenType),
                    Authorization: `Bearer ${token}`
                }
            }
        );
        return res.data;
    } catch (error) {
        console.error("Error fetching count orders:", error);
        throw error;
    }
};

export const AddTicketsToOrder = async (baseUrl, tokenType, token, orderId, addTicketsToOrderApiModel) => {
    try {
        const res = await axios.post(
            `${baseUrl}/ShopBasket/Order/${orderId}/Tickets`,
            addTicketsToOrderApiModel,
            {
                headers: {
                    ...getAuthHeader(tokenType),
                    Authorization: `Bearer ${token}`
                }
            }
        );
        return res;
    } catch (error) {
        console.error("Error adding tickets to order:", error);
        throw error;
    }
};

export const ChangeDeliveryMethod = async (baseUrl, tokenType, token, orderId, deliveryMethodId) => {
    try {
        const res = await axios.put(
            `${baseUrl}/ShopBasket/Order/${orderId}/DeliveryMethod/${deliveryMethodId}`,
            {
                headers: {
                    ...getAuthHeader(tokenType),
                    Authorization: `Bearer ${token}`
                }
            }
        );
        return res;
    } catch (error) {
        console.error("Error chaging delivery method:", error);
        throw error;
    }
};

export const ChangePaymentType = async (baseUrl, tokenType, token, orderId, paymentTypeId) => {
    try {
        const res = await axios.put(
            `${baseUrl}/ShopBasket/Order/${orderId}/PaymentType/${paymentTypeId}`,
            {
                headers: {
                    ...getAuthHeader(tokenType),
                    Authorization: `Bearer ${token}`
                }
            }
        );
        return res;
    } catch (error) {
        console.error("Error chaging payment type:", error);
        throw error;
    }
};

export const GetPdfTicketsOfOrderByOrderId = async (baseUrl, tokenType, token, orderId, organizerId) => {
    try {
        const res = await axios.get(
            `${baseUrl}/Order/${orderId}/TicketsPdf?organizerId=${organizerId}`,
            {
                headers: {
                    ...getAuthHeader(tokenType),
                    Authorization: `Bearer ${token}`
                },
                responseType: "blob",
            }
        );
        return res.data;
    } catch (error) {
        console.error("Error fetching the ticket pdf:", error);
        throw error;
    }
};

export const GetReceiptOfOrderByOrderId = async (baseUrl, tokenType, token, orderId, organizerId) => {
    try {
        const res = await axios.get(
            `${baseUrl}/Order/${orderId}/Receipt?organizerId=${organizerId}`,
            {
                headers: {
                    ...getAuthHeader(tokenType),
                    Authorization: `Bearer ${token}`
                },
                responseType: "blob",
            }
        );
        return res.data;
    } catch (error) {
        console.error("Error fetching the receipt pdf:", error);
        throw error;
    }
};

/* tickets */

export const GetTicketsOfOrder = async (baseUrl, tokenType, token, orderId) => {
    try {
        const res = await axios.get(
            `${baseUrl}/Order/${orderId}/Tickets`,
            {
                headers: {
                    ...getAuthHeader(tokenType),
                    Authorization: `Bearer ${token}`
                }
            }
        );
        return res.data;
    } catch (error) {
        console.error("Error fetching tickets of order:", error);
        throw error;
    }
};

export const GetTicketSoldOfEvent = async (baseUrl, tokenType, token, eventId) => {
    try {
        const res = await axios.get(
            `${baseUrl}/Event/${eventId}/TicketsSold`,
            {
                headers: {
                    ...getAuthHeader(tokenType),
                    Authorization: `Bearer ${token}`
                }
            }
        );
        return res.data;
    } catch (error) {
        console.error("Error fetching ticket sold of event:", error);
        throw error;
    }
};

export const UpdateTicketAddress = async (baseUrl, tokenType, token, ticketId, ticketApiModel) => {
    try {
        const res = await axios.put(
            `${baseUrl}/Ticket/${ticketId}/Address`,
            ticketApiModel,
            {
                headers: {
                    ...getAuthHeader(tokenType),
                    Authorization: `Bearer ${token}`
                }
            }
        );
        return res.data;
    } catch (error) {
        console.error("Error updating ticket address:", error);
        throw error;
    }
};

export const deleteTicketsFromBasket = async (baseUrl, tokenType, token, orderId, ticketIds) => {
    try {
        const res = await axios.delete(
            `${baseUrl}/ShopBasket/Order/${orderId}/Tickets`,
            {
                data: { TicketsToRemove: ticketIds },
                headers: {
                    ...getAuthHeader(tokenType),
                    Authorization: `Bearer ${token}`
                }
            }
        );
        return res.data;
    } catch (error) {
        console.error("Error deleting tickets:", error);
        throw error;
    }
};

/* event */

export const GetEventById = async (baseUrl, tokenType, token, eventId) => {
    try {
        const res = await axios.get(
            `${baseUrl}/Event/${eventId}`,
            {
                headers: {
                    ...getAuthHeader(tokenType),
                    Authorization: `Bearer ${token}`
                }
            }
        );
        return res.data;
    } catch (error) {
        console.error("Error fetching event by eventid:", error);
        throw error;
    }
};

export const GetEventsThatAreInEventGroup = async (baseUrl, tokenType, token, eventGroupId, language, eventBatchSize, numberToSkip, dateFrom = "", dateTo = "") => {
    try {
        const res = await axios.get(
            `${baseUrl}/EventGroup/Events?eventGroupId=${eventGroupId}&languageCode=${language}&numberToTake=${eventBatchSize}&numberToSkip=${numberToSkip}&dateFrom=${dateFrom}&dateTo=${dateTo}`,
            {
                headers: {
                    ...getAuthHeader(tokenType),
                    Authorization: `Bearer ${token}`
                }
            }
        );
        return res.data;
    } catch (error) {
        console.error("Error fetching event by eventid:", error);
        throw error;
    }
};

export const CountEventsThatAreInEventGroup = async (baseUrl, tokenType, token, eventGroupId, dateFrom = "", dateTo = "") => {
    try {
        const res = await axios.get(
            `${baseUrl}/EventGroup/${eventGroupId}/Events/Count?dateFrom=${dateFrom}&dateTo=${dateTo}`,
            {
                headers: {
                    ...getAuthHeader(tokenType),
                    Authorization: `Bearer ${token}`
                }
            }
        );
        return res.data;
    } catch (error) {
        console.error("Error fetching count events that are in event group:", error);
        throw error;
    }
};

/* ticket Types */

export const GetTicketTypeById = async (baseUrl, tokenType, token, id) => {
    try {
        const res = await axios.get(
            `${baseUrl}/TicketType/${id}`,
            {
                headers: {
                    ...getAuthHeader(tokenType),
                    Authorization: `Bearer ${token}`
                }
            }
        );
        return res.data;
    } catch (error) {
        console.error("Error fetching ticket type by id:", error);
        throw error;
    }
};

export const GetTicketTypesByEventId = async (baseUrl, tokenType, token, eventId) => {
    try {
        const res = await axios.get(
            `${baseUrl}/Event/${eventId}/TicketTypes`,
            {
                headers: {
                    ...getAuthHeader(tokenType),
                    Authorization: `Bearer ${token}`
                }
            }
        );
        return res.data;
    } catch (error) {
        console.error("Error fetching ticket type by eventid:", error);
        throw error;
    }
};

/* ticket Type infos */

export const GetTicketTypeInfosByTicketTypeId = async (baseUrl, tokenType, token, ticketTypeId) => {
    try {
        const res = await axios.get(
            `${baseUrl}/TicketType/${ticketTypeId}/Infos`,
            {
                headers: {
                    ...getAuthHeader(tokenType),
                    Authorization: `Bearer ${token}`
                }
            }
        );
        return res.data;
    } catch (error) {
        console.error("Error fetching infos of ticket type:", error);
        throw error;
    }
};

/* promotion code */

export const ApplyPromotionCode = async (baseUrl, tokenType, token, orderId, code) => {
    try {
        const res = await axios.put(
            `${baseUrl}/ShopBasket/Order/${orderId}/PromotionCode/${code}`,
            {
                headers: {
                    ...getAuthHeader(tokenType),
                    Authorization: `Bearer ${token}`
                }
            }
        );
        return res;
    } catch (error) {
        console.error("Error applying promotioncode:", error);
        throw error;
    }
};

/* timeslots */

export const GetTimeSlotsForEvent = async (baseUrl, tokenType, token, eventId) => {
    try {
        const res = await axios.get(
            `${baseUrl}/Event/${eventId}/TimeSlots`,
            {
                headers: {
                    ...getAuthHeader(tokenType),
                    Authorization: `Bearer ${token}`
                }
            }
        );
        return res.data;
    } catch (error) {
        console.error("Error fetching timeslots by eventid:", error);
        throw error;
    }
};

/* timeslot Availability Override */

export const GetTimeSlotAvailabilityOverrides = async (baseUrl, tokenType, token, eventId) => {
    try {
        const res = await axios.get(
            `${baseUrl}/TimeSlot/${eventId}/AvailabilityOverrides`,
            {
                headers: {
                    ...getAuthHeader(tokenType),
                    Authorization: `Bearer ${token}`
                }
            }
        );
        return res.data;
    } catch (error) {
        console.error("Error fetching timeslot availability override by eventid:", error);
        throw error;
    }
};

export const InsertTimeSlotAvailabilityOverride = async (baseUrl, tokenType, token, timeSlotAvailabilityOverrideApiModel) => {
    try {
        const res = await axios.post(
            `${baseUrl}/TimeSlotAvailabilityOverride`,
            timeSlotAvailabilityOverrideApiModel,
            {
                headers: {
                    ...getAuthHeader(tokenType),
                    Authorization: `Bearer ${token}`
                }
            }
        );
        return res.data;
    } catch (error) {
        console.error("Error inserting timeslot availability override:", error);
        throw error;
    }
};

export const DeleteTimeSlotAvailabilityOverride = async (baseUrl, tokenType, token, timeSlotAvailabilityOverrideApiModel) => {
    try {
        const res = await axios.delete(
            `${baseUrl}/TimeSlotAvailabilityOverride`,
            {
                data: timeSlotAvailabilityOverrideApiModel,
                headers: {
                    ...getAuthHeader(tokenType),
                    Authorization: `Bearer ${token}`
                }
            }
        );
        return res.data;
    } catch (error) {
        console.error("Error deleting timeslot availability override:", error);
        throw error;
    }
};

/* country */

export const getCountries = async (baseUrl, tokenType, token, language) => {
    try {
        const res = await axios.get(
            `${baseUrl}/Countries?languageCode=${language}`,
            {
                headers: {
                    ...getAuthHeader(tokenType),
                    Authorization: `Bearer ${token}`
                }
            }
        );
        return res.data;
    } catch (error) {
        console.error("Error geting the countries", error);
        return null;
    }
};